import { ReactNode, MouseEvent } from 'react'
import { Box, styled, useTheme } from '@mui/material'
import { Button, Typography } from '@carto/meridian-ds/components'
import RoundedIcon from 'features/common/ui/RoundedIcon'

const ButtonRoot = styled(Button)(({ theme }) => ({
  width: '100%',
  maxWidth: '100%',
  height: 'auto',
  padding: theme.spacing(1.5),

  '.MuiTypography-root': {
    display: 'flex',
    justifyContent: 'flex-start',
    textAlign: 'left',
    gap: theme.spacing(2)
  },

  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}))

interface HomeOnboardingWelcomeButtonProps {
  icon: ReactNode
  title: ReactNode
  description: ReactNode
  onClick?: (e: MouseEvent) => void
}

export function HomeOnboardingWelcomeButton({ icon, title, description, onClick }: HomeOnboardingWelcomeButtonProps) {
  const theme = useTheme()

  return (
    <ButtonRoot onClick={onClick}>
      <RoundedIcon icon={icon} backgroundColor={theme.palette.primary.relatedLight} size="medium" />
      <Box>
        <Typography variant="subtitle1">{title}</Typography>
        <Typography color="textSecondary" variant="body2">
          {description}
        </Typography>
      </Box>
    </ButtonRoot>
  )
}

export default HomeOnboardingWelcomeButton
